export function formatByteSize(bytes: number | undefined, mode: 'si' | 'simplified-units' | 'iec-units' = 'simplified-units', precision = 2) {
  let formattedBytes = bytes
  if (formattedBytes === undefined) {
    return 'Unknown'
  }

  const threshold = mode === 'si' ? 1000 : 1024
  if (Math.abs(formattedBytes) < threshold) {
    return `${formattedBytes} B`
  }
  const units =
    mode === 'si'
      ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      : mode === 'iec-units'
        ? ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
        : ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  let unitIndex = -1
  const r = 10 ** precision
  do {
    formattedBytes /= threshold
    ++unitIndex
  } while (Math.round(Math.abs(formattedBytes) * r) / r >= threshold && unitIndex < units.length - 1)

  return `${formattedBytes.toFixed(precision)}\u00A0${units[unitIndex]}`
}
